module.exports = __webpack_public_path__ + "static/media/analogicos-03.02d8f448.png";